import React from 'react';
import { useState } from 'react';
import { Modal } from 'react-bootstrap';
import 'react-tagsinput/react-tagsinput.css'
import { postWithAuth } from '../../../api/api';
import { API_URLS } from '../../../api/apiConfig';

const ModalNewProperty = ({onClose}) => {

    const [showAlert, setIshowAlert] = useState(false);
    const [alertMessage, setShowAlertMessage] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    
    const [newProperty, setProperty] = useState({
        name: "",
        rr_code: "",
    });

    const handleInputChange = (e) => {
        const { name, value, type } = e.target;
    
        setProperty((prevProperty) => {
            const newProperty = {
                ...prevProperty,
                [name]: type === 'checkbox' ? !prevProperty[name] : value,
            };

    
            return newProperty;
        });
    
    };

    const saveMap = async (e) => {

        const formData = new FormData();
        formData.append('data', JSON.stringify(newProperty));
        try {
            setIsLoading(true)
            const response = await postWithAuth(
                API_URLS.NEW_PROPERTY,
                newProperty
            );
            console.log("FormData", formData)
            if (response.message === 'success') {
                setIsLoading(false)
                window.location.reload();
            } else if (response.message === 'error') {
                setIsLoading(false)
                setIshowAlert(true);
                setShowAlertMessage(response.detail)
            } else {
                //setAlertType('danger');
                //setMessage("Error inesperado");
                //setShowAlertHeader(true);
            }
        } catch (error) {
            console.error('Error creating user admin:', error);
        }

    };

    const handleSave = async (e) => {
        e.preventDefault();

        try {
            saveMap();
        } catch (error) {
            console.error('Error creating user:', error);
        }
    };

    return (
        <>

            <Modal show={true} onHide={onClose} size="xl" centered>
            <Modal.Header closeButton>
                <Modal.Title>Nueva propiedad</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <form className="form fv-plugins-bootstrap5 fv-plugins-framework" action="#" data-select2-id="select2-data-kt_modal_create_api_key_form">
                    <div className="modal-body py-10 px-lg-17" data-select2-id="select2-data-108-9vb6">
                        <div className="scroll-y me-n7 pe-7" id="kt_modal_create_api_key_scroll" data-kt-scroll="true" data-kt-scroll-activate="{default: false, lg: true}" data-kt-scroll-max-height="auto" data-kt-scroll-dependencies="#kt_modal_create_api_key_header" data-kt-scroll-wrappers="#kt_modal_create_api_key_scroll" data-kt-scroll-offset="300px" data-select2-id="select2-data-kt_modal_create_api_key_scroll">
                            {showAlert && (
                            <div className="alert alert-danger d-flex align-items-center p-5">
                                <i className="fa-solid fa-triangle-exclamation fs-1 text-danger me-4"><span className="path1"></span><span className="path2"></span></i>
                                <div className="d-flex flex-column">
                                    <span className="mb-1 text-danger">{alertMessage}</span>
                                </div>
                            </div>
                            )}


                            <div className="row g-9 mb-8">
                            <div className="col-md-6 fv-row fv-plugins-icon-container">
                                <label className="required fs-6 fw-semibold mb-2">Nombre</label>
                                <input 
                                type="text" 
                                className="form-control form-control-solid" 
                                placeholder="" 
                                name="name"
                                onChange={handleInputChange}
                                defaultValue={""}
                                />
                            </div>
                            <div className="col-md-6 fv-row fv-plugins-icon-container">
                                <label className="required fs-6 fw-semibold mb-2">Código RoomRaccoon</label>
                                <input 
                                type="text" 
                                className="form-control form-control-solid" 
                                placeholder="" 
                                name="rr_code"
                                onChange={handleInputChange}
                                defaultValue={""}
                                />
                            </div>
                            </div>

                        </div>
                    </div>

                    <div className="modal-footer flex-center">

                        <button type="reset" id="kt_modal_create_api_key_cancel" className="btn btn-light me-3">
                            Cancelar
                        </button>
                        <button type="submit" onClick={handleSave} className="btn btn-primary" data-kt-indicator={`${isLoading ? 'on' : 'off'}`}>
                            <span className="indicator-label">
                                Crear propiedad
                            </span>
                            <span className="indicator-progress">
                                Creando... <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                            </span>
                        </button>

                    </div>

                </form>

            </Modal.Body>
        </Modal>

        </>

    );
};

export default ModalNewProperty;